/* eslint-disable react-hooks/exhaustive-deps */
import { useMemo, useEffect, createContext } from "react";
import { useSelector } from "react-redux";
import { io, Socket } from "socket.io-client";
import { RootState } from "app/store";
import { fetchAuthToken } from "app/Auth";
import Constants from "common/constant";

export interface Connection {
  socket?: Socket;
}
const connection: Connection = {
  socket: null,
};
export const ConnectionContext = createContext(connection);

export const PeerConnection = ({
  callee,
  connect,
  peerIdRef,
  setPeerId,
  handleSocketConnect,
  handleSocketMessage,
  handleSocketDisconnect,
  children,
}: {
  callee: boolean;
  connect: boolean;
  peerIdRef?: React.MutableRefObject<string>;
  setPeerId?: (peerId: string) => void;
  handleSocketConnect?: () => void;
  handleSocketMessage?: (data: any) => void;
  handleSocketDisconnect?: () => void;
  children?: React.ReactNode;
}) => {
  const user = useSelector((state: RootState) => state.user.appUser);

  const socket = useMemo(
    () =>
      io(Constants.wsHost, {
        autoConnect: false,
        auth: async (cb) => {
          cb({ token: await fetchAuthToken() });
        },
        query: { uid: user.active.uid, env: "web" },
      }),
    []
  );

  useEffect(() => {
    socket.on("connect", () => {
      console.log("connect: ", socket.id);
      if (setPeerId) {
        setPeerId(socket.id);
      } else {
        socket.emit("join_room", {
          room_id: peerIdRef.current,
        });
      }
    });
    socket.on("peer_connect", () => {
      console.log("peer connect: ", socket.id);
      if (handleSocketConnect) {
        handleSocketConnect();
      }
    });
    socket.on("analysis", async (message) => {
      console.log("analysis", message);
      const { data } = message;
      if (handleSocketMessage) {
        handleSocketMessage(data);
      }
    });
    socket.on("peer_disconnect", async () => {
      console.log("peer disconnect.");
      if (handleSocketDisconnect) {
        handleSocketDisconnect();
      }
    });
    socket.on("disconnect", async () => {
      console.log("socket disconnect.");
      if (handleSocketDisconnect) {
        handleSocketDisconnect();
      }
    });
    return () => {
      if (socket) {
        console.log("clean up socket and listeners.");
        socket.removeAllListeners();
        socket.disconnect();
      }
    };
  }, []);

  useEffect(() => {
    if (connect) {
      console.log("start to connect.");
      socket.connect();
      if (callee) {
        console.log("callee.");
        socket.send("hello I'm callee.");
      } else {
        console.log("caller.");
        socket.send("hello I'm caller.");
      }
    }

    return () => {
      if (socket) {
        console.log("clean up socket by connect.");
        socket.disconnect();
      }
    };
  }, [connect]);

  return (
    <ConnectionContext.Provider value={{ socket }}>
      {children}
    </ConnectionContext.Provider>
  );
};
